import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const ReservationsTransactions = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default ReservationsTransactions;
